import { Maybe } from 'maybeasy';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { currentUserStore } from '../../../../../../CurrentUserStore';
import { findLink } from '../../../../../../LinkyLinky';
import { T } from '../../../../../../Translations';

export interface Props {
  id: number;
}

// v2 is the primary experience, so this reads as plain "Edit". When v1 is
// also visible (org opted into show_builder_v1), the v1 counterpart
// (EditLink) disambiguates itself as "Edit (classic)".
export const editV2Link = ({ id }: Props): Maybe<React.ReactNode> =>
  findLink('edit-learning-collection-template-v2', currentUserStore.links).map(() => (
    <Link
      key="edit-learning-collection-template-v2"
      to={`/learning_collections/builder_v2/${id}`}
      className="px-4 py-2.5"
      data-intercom-target="edit-collection-v2-action"
    >
      <T kind="Edit" />
    </Link>
  ));
